<template>
  <apex-chart-card
    v-if="hasData"
    :key="genderAndAgeMetricsChartKey"
    style="height: 100%"
    chart-title="Ticket médio por gênero e idade"
    :chart-description="filteredCardDescription"
    :chart-data="ticketByGenderAndAgeChartData"
    :series-data="seriesData"
    filter-by-date-period="MONTH"
    :config-update-options="configUpdateOptions"
    :chart-loading="loading"
    card-height="345"
    is-simple-chart
  />
  <mf-card-container v-else style="height: 100%" title="Ticket médio por gênero e idade">
    <empty-chart />
  </mf-card-container>
</template>

<script>
import { abbreviation } from '@/config/helpers.js'

import EmptyChart from '@/modules/mobile/desempenho/views/components/EmptyChart'
import ApexChartCard from '@/components/ApexChartCard.vue'
import { filteredCardDescription } from '@/modules/maria/campanha-da-maria-v2/mixins/filtered-card-description'

export default {
  name: 'GenderAndAgeMetricsChart',

  components: {
    ApexChartCard,
    EmptyChart,
  },

  mixins: [filteredCardDescription],

  props: {
    dataChart: {
      type: Object,
      required: true,
    },
    chosenCustomerType: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    genderAndAgeMetricsChartKey: 1,
    colors: ['#002040', '#0063C6', '#C3C8CD'],
  }),

  computed: {
    hasData() {
      if (!this.ticketByGenderAndAgeChartData.length) return false
      return (
        this.ticketByGenderAndAgeChartData.reduce((total, valor) => total + valor.man, 0) +
        this.ticketByGenderAndAgeChartData.reduce((total, valor) => total + valor.woman, 0) +
        this.ticketByGenderAndAgeChartData.reduce((total, valor) => total + valor.others, 0)
      )
    },

    ticketByGenderAndAgeChartData() {
      if (!this.dataChart.metrics.length) return []

      return [
        {
          man: this.dataChart.metrics[0] ? this.dataChart.metrics[0][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[0] ? this.dataChart.metrics[0][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[0] ? this.dataChart.metrics[0][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['sem dados'],
        },
        {
          man: this.dataChart.metrics[7] ? this.dataChart.metrics[7][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[7] ? this.dataChart.metrics[7][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[7] ? this.dataChart.metrics[7][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['-18'],
        },
        {
          man: this.dataChart.metrics[1] ? this.dataChart.metrics[1][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[1] ? this.dataChart.metrics[1][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[1] ? this.dataChart.metrics[1][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['18 - 24'],
        },
        {
          man: this.dataChart.metrics[2] ? this.dataChart.metrics[2][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[2] ? this.dataChart.metrics[2][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[2] ? this.dataChart.metrics[2][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['25 - 34'],
        },
        {
          man: this.dataChart.metrics[3] ? this.dataChart.metrics[3][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[3] ? this.dataChart.metrics[3][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[3] ? this.dataChart.metrics[3][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['35 - 44'],
        },
        {
          man: this.dataChart.metrics[4] ? this.dataChart.metrics[4][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[4] ? this.dataChart.metrics[4][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[4] ? this.dataChart.metrics[4][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['45 - 54'],
        },
        {
          man: this.dataChart.metrics[5] ? this.dataChart.metrics[5][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[5] ? this.dataChart.metrics[5][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[5] ? this.dataChart.metrics[5][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['55 - 64'],
        },
        {
          man: this.dataChart.metrics[6] ? this.dataChart.metrics[6][this.chosenCustomerType].male.average_ticket : 0,
          woman: this.dataChart.metrics[6] ? this.dataChart.metrics[6][this.chosenCustomerType].female.average_ticket : 0,
          others: this.dataChart.metrics[6] ? this.dataChart.metrics[6][this.chosenCustomerType].unknown_gender.average_ticket : 0,
          label: ['+65'],
        },
      ]
    },

    clientsByGenderAndAgeChartData() {
      if (!this.dataChart.metrics.length) return []

      return {
        man: this.dataChart.totals[this.chosenCustomerType].male.clients,
        woman: this.dataChart.totals[this.chosenCustomerType].female.clients,
        others: this.dataChart.totals[this.chosenCustomerType].unknown_gender.clients,
      }
    },

    seriesData() {
      return [
        {
          name: 'Homens',
          chartDataPropertyName: 'man',
          totals: this.clientsByGenderAndAgeChartData.man,
        },
        {
          name: 'Mulheres',
          chartDataPropertyName: 'woman',
          totals: this.clientsByGenderAndAgeChartData.woman,
        },
        {
          name: 'Outros',
          chartDataPropertyName: 'others',
          totals: this.clientsByGenderAndAgeChartData.others,
        },
      ]
    },

    configUpdateOptions() {
      return {
        chart: {
          type: 'bar',
          stacked: false,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          background: '#fff',
        },
        plotOptions: {
          bar: {
            columnWidth: '60px',
            borderRadius: 3,
            dataLabels: {
              position: 'top',
            },
          },
        },
        fill: {
          opacity: 1,
          type: 'solid',
        },
        grid: {
          padding: {
            top: 10,
            right: 10,
            bottom: 10,
            left: 10,
          },
        },
        colors: [...this.colors],
        legend: {
          horizontalAlign: 'left',
          position: 'bottom',
          fontSize: '14px',
          markers: {
            shape: 'square',
          },
          formatter: function (seriesName, opts) {
            const seriesTotal = opts.w.config.series[opts.seriesIndex].totals
            const seriesNameLegend = `<span class="pr-1 cinza-d10-text"">${seriesName}</span>`
            const color = opts.w.config.colors[opts.seriesIndex]
            const seriesTotalLegend = `<br><span style="font-weight: bold; font-size: 14px; color: ${color}">${seriesTotal.toLocaleString()}</span>`
            return `${seriesNameLegend}${seriesTotalLegend}</td>`
          },
          onItemClick: {
            toggleDataSeries: false,
          },
          itemMargin: {
            horizontal: 15,
          },
        },
        markers: {
          size: 2,
          colors: [...this.colors],
          strokeColors: [...this.colors],
          strokeWidth: 2,
          strokeOpacity: 1,
          strokeDashArray: 0,
          fillOpacity: 1,
          shape: 'circle',
          radius: 2,
          showNullDataPoints: true,
          hover: {
            sizeOffset: 2,
          },
        },
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const colors = w.config.colors
            const title = `${this.ticketByGenderAndAgeChartData[dataPointIndex].label[0]} ${dataPointIndex ? 'anos' : ''}`
            return `
                  <v-card class="py-2">
                    <v-card-text>
                      <div class="px-4 tooltip-gender-and-age-metrics-chart">
                        <span class="title-gender-and-age">${title}</span>
                        <h3 class="mt-n1">
                          <span class="description-gender-and-age">${this.getTotalClientesByAge(dataPointIndex).toLocaleString()} ${
              this.getTotalClientesByAge(dataPointIndex).toLocaleString() === '1' ? `consumidor` : `consumidores`
            }</span>
                        </h3>

                        <div class="d-flex flex-row justify-space-between py-1" style="border-bottom: 1px solid #D2D6D9;">
                          <div class="d-flex flex-column justify-start align-start">
                            <span class="legend-gender-and-age-title">Homens</span>
                            <span class="legend-gender-and-age" style="color: ${colors[0]}">${this.getTotalClientesByGenderFromAgeIndex(
              dataPointIndex,
              'male'
            ).toLocaleString()}</span>
                          </div>
                          <div class="d-flex flex-column justify-end align-end">
                            <span class="legend-gender-and-age-title">Ticket médio</span>
                            <span class="legend-gender-and-age" style="color: ${colors[0]}">R$ ${abbreviation(series[0][dataPointIndex], {
              isCurrency: true,
            })}</span>
                          </div>
                        </div>

                        <div class="d-flex flex-row justify-space-between py-1" style="border-bottom: 1px solid #D2D6D9;">
                          <div class="d-flex flex-column justify-start align-start">
                            <span class="legend-gender-and-age-title">Mulheres</span>
                            <span class="legend-gender-and-age" style="color: ${colors[1]}">${this.getTotalClientesByGenderFromAgeIndex(
              dataPointIndex,
              'female'
            ).toLocaleString()}</span>
                          </div>
                          <div class="d-flex flex-column justify-end align-end">
                            <span class="legend-gender-and-age-title">Ticket médio</span>
                            <span class="legend-gender-and-age" style="color: ${colors[1]}">R$ ${abbreviation(series[1][dataPointIndex], {
              isCurrency: true,
            })}</span>
                          </div>
                        </div>

                        <div class="d-flex flex-row justify-space-between py-1">
                          <div class="d-flex flex-column justify-start align-start">
                            <span class="legend-gender-and-age-title">Outros</span>
                            <span class="legend-gender-and-age" style="color: ${colors[2]}">${this.getTotalClientesByGenderFromAgeIndex(
              dataPointIndex,
              'unknown_gender'
            ).toLocaleString()}</span>
                          </div>
                          <div class="d-flex flex-column justify-end align-end">
                            <span class="legend-gender-and-age-title">Ticket médio</span>
                            <span class="legend-gender-and-age" style="color: ${colors[2]}">R$ ${abbreviation(series[2][dataPointIndex], {
              isCurrency: true,
            })}</span>
                          </div>
                        </div>

                      </div>
                    </v-card-text>
                  </v-card>
                `
          },
        },
        dataLabels: {
          enabled: false,
          position: 'top',
          offsetY: -23,
          style: {
            fontSize: '14px',
            colors: ['rgba(248, 249, 250, 0.82)'],
            fontWeight: 'normal',
          },
          background: {
            enabled: true,
            foreColor: 'rgba(0, 0, 0, 0.54)',
            padding: 4,
            borderRadius: 2,
          },
          formatter: (value) => {
            if (!value) return
            return `R$ ${abbreviation(value, { isCurrency: true })}`
          },
        },
        stroke: {
          colors: ['transparent'],
          width: 5,
        },
      }
    },
  },

  watch: {
    chosenCustomerType() {
      this.genderAndAgeMetricsChartKey += 1
    },
  },

  methods: {
    formatterAgeIndex(index) {
      switch (index) {
        case 0:
          return 0
        case 1:
          return 7
        case 2:
          return 1
        case 3:
          return 2
        case 4:
          return 3
        case 5:
          return 4
        case 6:
          return 5
        default:
          return 6
      }
    },

    getTotalClientesByAge(ageIndex) {
      ageIndex = this.formatterAgeIndex(ageIndex)
      let totals = this.dataChart.metrics[ageIndex][this.chosenCustomerType].male.clients
      totals += this.dataChart.metrics[ageIndex][this.chosenCustomerType].female.clients
      totals += this.dataChart.metrics[ageIndex][this.chosenCustomerType].unknown_gender.clients
      return totals
    },

    getTotalClientesByGenderFromAgeIndex(ageIndex, gender) {
      ageIndex = this.formatterAgeIndex(ageIndex)
      return this.dataChart.metrics[ageIndex][this.chosenCustomerType][gender].clients
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .gender-and-age-metrics-chart-color {
  color: $marca-1;
}
::v-deep .gender-and-age-metrics-chart-neutral-color {
  color: $cinza-0;
}
::v-deep .cinza-l30-text {
  color: $cinza-l30;
  font-size: 14px;
  margin-bottom: 5p;
}
::v-deep .cinza-d20-text {
  color: $cinza-d20;
  font-weight: 500;
  font-size: 18px;
}

::v-deep .tooltip-gender-and-age-metrics-chart {
  width: 192px;

  .title-gender-and-age {
    font-size: 16px;
    font-weight: bold;
    color: $cinza-d20;
  }

  .description-gender-and-age {
    font-size: 14px;
    font-weight: normal;
    color: $cinza-d10;
  }

  .legend-gender-and-age-title {
    font-weight: normal;
    font-size: 12px;
    color: $cinza-d10;
  }

  .legend-gender-and-age {
    font-weight: 700;
    font-size: 14px;
  }
}
</style>
